/*eslint-disable */
define(function(require) {

	var pageConfig		= require('common/page-config');

	function attachMessages() {
		var validationMessages = pageConfig.validationMessages;
		$.extend($.validator.messages, validationMessages);
	}

	return {
		attachMessages: attachMessages
	}

})